import React from 'react'

import { useAuth } from 'src/modules/auth'
import { SecondaryNavLayout } from 'src/modules/ui'

import EnvironmentSelector from './EnvironmentSelector'
import InventoryListView from './views/InventoryListView'
import InventoryLocationView from './views/InventoryLocationView'
import InventoryEditView from './views/InventoryEditView'

const Inventory = () => {
  const { user } = useAuth()

  const routes = [
    {
      navLabel: 'Inventory',
      path: '/inventory',
      exact: true,
      component: InventoryListView,
    },
    {
      navLabel: 'Locations',
      path: '/inventory/locations',
      exact: true,
      component: InventoryLocationView,
    },
  ]

  routes.push(
    ...[
      {
        path: '/inventory/:id/edit',
        component: InventoryEditView,
        title: 'Edit an Inventory Environment',
      },
    ]
  )

  let extraControl
  if (user.organisation.environmentCount > 1) {
    extraControl = <EnvironmentSelector />
  }

  return <SecondaryNavLayout extraControl={extraControl} routes={routes} />
}

export default Inventory
